<template>
  <section>
    <ModalBase
      :title="getTitle()"
      :isShowModal="isShowModal"
      :canCancel="false"
      :width="'680px'"
      :height="'auto'"
      :close="modalClose"
    >
      <div class="card" style="border-radius: 5px;">
        <!-- メッセージ -->
        <div class="card-content disp-scroll">
          <p>
            <!-- 警告メッセージ -->
            <b-message type="is-warning" has-icon v-if="getAlertIcon() === ICON_WARNING">
              <p v-html="getAlertMessage()"></p>
            </b-message>
            <!-- 情報メッセージ -->
            <b-message type="is-info" has-icon v-else-if="getAlertIcon() === ICON_INFO">
              <p v-html="getAlertMessage()"></p>
            </b-message>
            <!-- 完了メッセージ -->
            <b-message type="is-success" has-icon v-else-if="getAlertIcon() === ICON_SUCCESS">
              <p v-html="getAlertMessage()"></p>
            </b-message>
            <!-- 危険メッセージ -->
            <b-message type="is-danger" has-icon v-else-if="getAlertIcon() === ICON_DANGER">
              <p v-html="getAlertMessage()"></p>
            </b-message>
            <!-- 通常メッセージ -->
            <b-message v-else>
              <p v-html="getAlertMessage()"></p>
            </b-message>
          </p>
        </div>
        <div v-show="getAlertType !== DISP_TOAST">
          <fieldset :disabled="isClicked">
            <!-- 確認アラート用 -->
            <footer class="card-footer" v-if="getAlertType() === DISP_CONFIRM">
              <a class="card-footer-item" @click="resultBuuton(RESULT_NO)">いいえ</a>
              <a class="card-footer-item" @click="resultBuuton(RESULT_YES)">はい</a>
            </footer>
            <!-- OK/Cancelアラート用 -->
            <footer class="card-footer" v-else-if="getAlertType() === DISP_OK_CANCEL">
              <a class="card-footer-item" @click="resultBuuton(RESULT_OK)">OK</a>
              <a class="card-footer-item" @click="resultBuuton(RESULT_CANCEL)">キャンセル</a>
            </footer>
            <!-- マルチボタンアラート用 -->
            <footer class="card-footer" v-else-if="getAlertType() === DISP_MULTIPLE">
              <a class="card-footer-item" @click="resultBuuton(value)" v-for="(value, key) in getAlertMultipleButton()" :key='key'>{{key}}</a>
            </footer>
            <!-- アラート用 -->
            <footer class="card-footer" v-else>
              <a class="card-footer-item" @click="resultBuuton(RESULT_OK)">OK</a>
            </footer>
          </fieldset>
        </div>
      </div>
    </ModalBase>
  </section>
</template>

<script>
// モーダルベース
import ModalBase from '@/hrm-frontend/views/atomic/screen-components/basic-components/base-modal/ModalBase'
import AlertDispFunctions from '@/hrm-frontend/modules/functions/alert-functions'

export default {
  name: 'AlertModal',
  componentName: 'AlertModal',
  components: {
    ModalBase,
  },
  data () {
    return {
      /**
       * モーダル表示フラグ
       * @type {Boolean}
       */
      isAlertModalActive: this.isAlertOpen,
      /**
       * クリック済みフラグ
       * @type {Boolean}
       */
      isClicked: false,
      /**
       * 警告アイコン
       * @type {String}
       */
      ICON_WARNING: AlertDispFunctions.ALERT_DEF.ICON_TYPE.WARNING,
      /**
       * 情報アイコン
       * @type {String}
       */
      ICON_INFO: AlertDispFunctions.ALERT_DEF.ICON_TYPE.INFO,
      /**
       * 正常終了アイコン
       * @type {String}
       */
      ICON_SUCCESS: AlertDispFunctions.ALERT_DEF.ICON_TYPE.SUCCESS,
      /**
       * 危険アイコン
       * @type {String}
       */
      ICON_DANGER: AlertDispFunctions.ALERT_DEF.ICON_TYPE.DANGER,
      /**
       * 標準アイコン
       * @type {String}
       */
      ICON_DEFAULT: AlertDispFunctions.ALERT_DEF.ICON_TYPE.DEFAULT,
      /**
       * トースト表示
       * @type {String}
       */
      DISP_TOAST: AlertDispFunctions.ALERT_DEF.DISP_TYPE.TOAST,
      /**
       * 確認表示
       * @type {String}
       */
      DISP_CONFIRM: AlertDispFunctions.ALERT_DEF.DISP_TYPE.CONFIRM,
      /**
       * OK/Cance表示
       * @type {String}
       */
      DISP_OK_CANCEL: AlertDispFunctions.ALERT_DEF.DISP_TYPE.OK_CANCEL,
      /**
       * マルチボタン表示
       * @type {String}
       */
      DISP_MULTIPLE: AlertDispFunctions.ALERT_DEF.DISP_TYPE.MULRIPLE,
      /**
       * アラート表示
       * @type {String}
       */
      DISP_ALERT: AlertDispFunctions.ALERT_DEF.DISP_TYPE.ALERT,
      /**
       * はいボタン押下
       * @type {String}
       */
      RESULT_YES: AlertDispFunctions.ALERT_DEF.RESULT_TYPE.YES,
      /**
       * いいえボタン押下
       * @type {String}
       */
      RESULT_NO: AlertDispFunctions.ALERT_DEF.RESULT_TYPE.NO,
      /**
       * OKボタン押下
       * @type {String}
       */
      RESULT_OK: AlertDispFunctions.ALERT_DEF.RESULT_TYPE.OK,
      /**
       * キャンセルボタン押下
       * @type {String}
       */
      RESULT_CANCEL: AlertDispFunctions.ALERT_DEF.RESULT_TYPE.CANCEL,
      /**
       * トースト表示最短時間(秒)
       * @type {String}
       */
      TOAST_DISP_MIN_TIME: AlertDispFunctions.ALERT_DEF.TOAST_DISP_MIN_TIME,
      /**
       * トースト表示最長時間(秒)
       * @type {String}
       */
      TOAST_DISP_MAX_TIME: AlertDispFunctions.ALERT_DEF.TOAST_DISP_MAX_TIME
    }
  },
  props: {
    /**
     * モーダル表示フラグ
     * @type {Object}
     */
    isShowModal: {
      type    : Boolean,
      default : false,
      required: true
    },
    /**
     * アラート表示データ
     * @type {Object}
     */
    alertData: {
      type: Object,
      required: true
    },
    /**
     * ボタン押下結果返却
     * @type {Function}
     */
    alertResult: {
      type: Function,
      required: true
    }
  },
  watch: {
    /** モーダル表示フラグ監視 */
    isShowModal () {
      this.isAlertModalActive = this.isShowModal
      if (this.isShowModal && this.alertData.alertType === AlertDispFunctions.ALERT_DEF.DIALOG_TOAST) {
        // トーストの場合、指定時間後にクローズ
        setTimeout(this.resultBuuton(this.RESULT_OK), this.alertData.alertToastTime ? Number(this.alertData.alertToastTime) : AlertDispFunctions.ALERT_DEF.TOAST_DISP_MIN_TIME)
      }
    }
  },
  methods: {
    /**
     * タイトル取得
     * @return {String} タイトル
     */
    getTitle () {
      // 改行削除
      if (this.alertData.alertTitle) {
        return this.alertData.alertTitle.replace(/\r?\n/g, ' ')
      } else {
        return ''
      }
    },
    /**
     * メッセージ取得
     * @return {String} メッセージ
     */
    getAlertMessage () {
      // 改行を置換
      if (this.alertData.alertMessage) {
        return this.$sanitize(this.alertData.alertMessage.replace(/\r?\n/g, '<br/>'))
      } else {
        return ''
      }
    },
    /**
     * メッセージ種別取得
     * @return {String} メッセージ種別
     */
    getAlertIcon () {
      if (this.alertData.iconType) {
        return this.alertData.iconType
      } else {
        return AlertDispFunctions.ALERT_DEF.ICON_DEFAULT
      }
    },
    /**
     * アラート種別取得
     * @return {String} アラート種別
     */
    getAlertType () {
      if (this.alertData.alertType) {
        return this.alertData.alertType
      } else {
        return this.DISP_ALERT
      }
    },
    /** マルチボタン取得  */
    /**
     * マルチボタン取得
     * @return {Object} マルチボタン
     */
    getAlertMultipleButton () {
      if (this.alertData.alertMultipleButton) {
        return this.alertData.alertMultipleButton
      } else {
        return {}
      }
    },
    /**
     * ボタン押下
     * @param {String} value ボタン押下結果
     */
    resultBuuton (value) {
      this.isClicked = true
      // ボタン押下結果オブジェクトテンプレート取得
      let result = JSON.parse(JSON.stringify(AlertDispFunctions.ALERT_DEF.RESULT_TEMPLATE))
      // 戻り値判定機能名
      result[AlertDispFunctions.ALERT_DEF.RESULT_TEMPLATE_KEY_NAME.KEY_FUNCTION] = this.alertData.alertKeyFunction
      // 戻り値判定キーワード
      result[AlertDispFunctions.ALERT_DEF.RESULT_TEMPLATE_KEY_NAME.KEY_WORD] = this.alertData.alertKeyWord
      // ボタン押下結果
      result[AlertDispFunctions.ALERT_DEF.RESULT_TEMPLATE_KEY_NAME.VALUE] = value

      // ボタン押下結果返却
      this.alertResult(result)
    },
    /**
     * モーダルクローズ
     */
    modalClose () {
      this.isClicked = false
      this.resultBuuton('')
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  max-height: 600px;
}
.card-content {
  max-height: 550px;
}
</style>



// WEBPACK FOOTER //
// src/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/AlertModal.vue